import { Route, Routes } from "react-router-dom";
import { paths } from "../utils/routes";
import Payment from "../pages/payment";

function PaymentRouter(props) {
  return (
    <Routes>
      <Route path={paths.base} element={<Payment />} />
    </Routes>
  );
}

export default PaymentRouter;
